import { useBlocker } from 'react-router-dom';

interface UseUnsavedChangesOptions {
  isDirty: boolean;
  message?: string;
}

interface UseUnsavedChangesReturn {
  showModal: boolean;
  confirmNavigation: () => void;
  cancelNavigation: () => void;
}

export function useUnsavedChanges({
  isDirty,
}: UseUnsavedChangesOptions): UseUnsavedChangesReturn {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname
  );

  const confirmNavigation = () => {
    if (blocker.state === 'blocked') {
      blocker.proceed();
    }
  };

  const cancelNavigation = () => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  };

  return {
    showModal: blocker.state === 'blocked',
    confirmNavigation,
    cancelNavigation,
  };
}
